import React, { useEffect, useState } from 'react'
import { BiMoon } from 'react-icons/bi'
import styled from 'styled-components'
import logo from '../assets/logo-3.png'

interface WrapperProps {
    isClick: boolean
}

const Wrapper = styled.div<WrapperProps>`
    display: flex;
    justify-content: space-between;
    #logo {
        position: absolute;
        width: 5vw;
    }
    .navBar {
        display: flex;
        gap: 24px;
        font-weight: 500;
        .options {
            display: flex;
            gap: 24px;
        }
    }
    .options {
        display: none;
        transition: 0.6s;
    }
    .button {
        display: none;
        background-color: transparent;
        color: ${props => props.theme.colors.text};
        border: none;
        align-items: center;
        gap: 5px;
        span {
            display: block;
            width: 20px;
            height: 2px;
            background-color: ${props => props.theme.colors.text};
            margin: 2px 0px;
            transition: 0.3s;
        }
    }

    @media (max-width: 900px) {
        .navBar a {
        ${({isClick}) => !isClick && `
            display: none;
            `}
        }
        .options {
            ${({isClick}) => isClick && `
                position: fixed;
                flex-direction: column;
                top: 0;
                left: 0;
                background-color: #333;
                padding: 50px;
                z-index: 1000;
                width: 100vw;
                height: 100vh;
                align-items: center;
                justify-content: center;
                .button {
                    position: absolute;
                    right: 10vw;
                    top: 10vh;
                    .icon {
                        span:first-child {
                            transform: translateY(3.5px) rotate(135deg);
                        }
                        span:nth-child(2) {
                            opacity: 0;
                        }
                        span:nth-child(3) {
                            transform: translateY(-3.5px) rotate(-135deg);
                        }
                    }
                }
            `}
        }
        .button {
            display: flex;
        }
        #logo {
            width: 10vw;
        }
    }
    @media (max-width: 450px) {
        #logo {
            width: 15vw;
        }
    }
`

interface HeaderProps {
    toggleTheme: (event: React.MouseEvent<HTMLDivElement>) => void
}

function Header({ toggleTheme }: HeaderProps) {

    const [isClick, setIsClick] = useState(false)

    function handleCLick() {
        setIsClick(isClick ? false : true)
    }

    function ExitMenu() {
        setIsClick(false)
    }

    useEffect(() => {
        if(isClick) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
        }
    }, [isClick])

    return (
        <Wrapper isClick={isClick}>
            <div>
                <img id='logo' alt='logo' src={logo} />
            </div>
            <nav className="navBar" >
                <div className="options">
                    <a onClick={ExitMenu} href='#aboutMe'>Sobre mim</a>
                    <a onClick={ExitMenu} href='#skills'>Habilidades</a>
                    <a onClick={ExitMenu} href='#services'>Serviços</a>
                    <a onClick={ExitMenu} href='#portfolio'>Portfólio</a>
                    <a onClick={ExitMenu} href='#contactMe'>Fale comigo</a>
                    <button onClick={handleCLick} className='button'>
                        <p>Menu</p>
                        <div  className="icon">
                            <span />
                            <span />
                            <span />
                        </div>
                    </button>
                </div>
                <div onClick={toggleTheme}>
                    <BiMoon />
                </div>
            </nav>
        </Wrapper>
    );
}

export default Header;